import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/Terms&PrivacySocialApi/SosialLinks";
import { validateForm } from "utils/validation";
import { SocialLinkRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditSocialLinkForm from "./Componates/EditSocialLinkForm";
import fields from "../json/TermsAndPrivacyFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditSocialLink = () => {
  const navigate = useNavigate();
  const { formdatasocial } = fields;
  const { id } = useParams();

  // Initialize default field values
  const initialValues = formdatasocial.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const {
    values,
    errors,
    handleChange,
    handleFileChange,
    setErrors,
    setValues,
  } = useFormChange(initialValues, SocialLinkRules);

  // Fetch data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdatasocial,
    GetById,
    setValues
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await Update({ id, data: formData });
    },
    (vals) => {
      // remove image key if it's a string (already uploaded)
      if (typeof vals.icon === "string") {
        delete vals.icon;
      }
      const err = validateForm(vals, SocialLinkRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Social link updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditSocialLinkForm
        fields={formdatasocial}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={
          values.iconPreview ||
          (values.icon && values.icon)
        }
        title="Update Social Link"
      />
    </>
  );
};

export default EditSocialLink;
